import Col from 'react-bootstrap/lib/Col'
import Icon, {icons} from './icon'
import Grid from 'react-bootstrap/lib/Grid'
import Markdown from './markdown'
import PropTypes from 'prop-types'
import React, {Component} from 'react'
import Row from 'react-bootstrap/lib/Row'
import {colors, media, text} from '../styles'
import {render as template} from '../shared/template'
import {css} from 'glamor'

const style = {
  expandIcon: css({
    position: 'absolute',
    right: '15px',
    top: 0
  }),
  base: css({
    padding: '15px',
    borderBottom: `1px solid ${colors.gray89}`,
    '& p': {
      margin: '0 15px 0 0'
    }
  }),
  col: css({
    ...media.xs({
      margin: '0 15px',
      width: 'calc(100% - 30px)'
    })
  }),
  collapsed: css({
    '& p': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }),
  markdown: css(text.finePrint, {
    color: colors.gray46
  })
}

export default class SeoTextDropdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      expanded: false
    }
  }

  toggleExpanded = () => {
    this.setState(state => ({
      expanded: !state.expanded
    }))
  }

  render() {
    const {block, content, context} = this.props
    const {expanded} = this.state

    return (
      <Grid
        fluid
        {...css(style.base, expanded ? null : style.collapsed)}
        onClick={this.toggleExpanded}>
        <Row>
          <Col
            xs={12}
            md={block ? 12 : 10}
            mdPush={block ? 0 : 1}
            lg={block ? 12 : 8}
            lgPush={block ? 0 : 2}
            lgPull={block ? 0 : 2}
            {...style.col}>
            <Markdown
              content={context ? template(content, context) : content}
              {...style.markdown}
            />
            <Icon
              icon={icons[`chevron${expanded ? 'Up' : 'Down'}`]}
              {...style.expandIcon}
            />
          </Col>
        </Row>
      </Grid>
    )
  }
}

SeoTextDropdown.propTypes = {
  context: PropTypes.object,
  block: PropTypes.bool,
  content: PropTypes.string.isRequired
}

SeoTextDropdown.defaultProps = {
  block: false
}
